import { useCallback, useState } from "react";
import { useModal } from "../../../../../utils/custom-hooks";
import {
  DuplicatePathResults,
  validateCurrentPathDuplicateOfExistingPaths,
} from "./custom-path-validator";
import { useAuthContextV2 } from "../../../../../auth-state";

export const useCustomPathValidator = (args: {
  orgId: string;
  procName: string;
  existingCurrentPath: string;
}): {
  customPathDuplicateError: DuplicatePathResults | undefined;
  customPathModalIsActive: boolean;
  isValidCurrentCustomPath: (customPath: string) => Promise<boolean>;
  closeCustomPathModal: () => void;
} => {
  const { orgId, procName, existingCurrentPath } = args;
  const customPathModal = useModal();
  const [customPathDuplicateError, setCustomPathDuplicateError] = useState<
    DuplicatePathResults | undefined
  >(undefined);
  const { auth } = useAuthContextV2();

  const isValidCurrentCustomPath = useCallback(
    async (customPath: string): Promise<boolean> => {
      const result = await validateCurrentPathDuplicateOfExistingPaths({
        orgId: orgId,
        newCurrentPath: customPath,
        existingCurrentPath: existingCurrentPath,
        procName: procName,
        auth: auth,
      });
      setCustomPathDuplicateError(result);
      if (result) {
        customPathModal.open();
        return false;
      }
      return true;
    },
    [orgId, existingCurrentPath, procName, auth, customPathModal],
  );

  const closeCustomPathModal = () => {
    customPathModal.close();
    setCustomPathDuplicateError(undefined);
  };

  return {
    customPathDuplicateError,
    customPathModalIsActive: customPathModal.isActive,
    isValidCurrentCustomPath,
    closeCustomPathModal,
  };
};
